module.exports = __webpack_public_path__ + "img/menu_5.dec0c9fb.png";